import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankStatementImportSection  {
    _originalTypeClassName = "zERP.BO.BankStatementImportSection";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankStatementImportSection.translate = translateService;
}
this.Rows = [];
this.Id = null;
this.FromDate = null;
this.ToDate = null;
this.OpeningBalance = null;
this.ClosingBalance = null;
this.NumberOfRecords = null;
this.SumAmount = null;
this.BankAccountIBAN = null;
this.IsFinalized = false;
this.HasCorrectBank = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FromDate:any;
ToDate:any;
OpeningBalance:any;
ClosingBalance:any;
NumberOfRecords:any;
SumAmount:any;
BankAccountIBAN:any;
IsFinalized:any;
HasCorrectBank:any;
BankAccount:any;
Rows:any;
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}
static setRows = ($this, items) => {
                if (items == null) items = [];
                if ($this.Rows == null) $this.Rows = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Rows.length > 0) {
                    Domain.BankStatementImportSection.removeRows($this, $this.Rows[0]);
                }

                Domain.BankStatementImportSection.addManyRows($this, copyItems);
            }
static addManyRows = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BankStatementImportSection.addRows($this, items[i]);
                }
            }
static addRows = ($this, item) => {
                if ($this.Rows == null) $this.Rows = [];
                if (item == null || $this.Rows.indexOf(item) > -1) return;
                $this.Rows.push(item);
if (item.Section != $this) {
Domain.BankStatementImportRow.setSection(item, $this);
}
}
static addRangeRows = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BankStatementImportSection.addRows($this, item));
            }
static removeRows = ($this, item) => {
                if ($this == null || $this.Rows == null || $this.Rows.indexOf(item) === -1) return;
                var _index = $this.Rows.indexOf(item);
                $this.Rows.splice(_index, 1);
item.Section = null;
}
static clearRows = ($this) => { $this.Rows = null; }

static FillRequiresInvoiceMatching($this: any): any{let bank = $this?.BankAccount?.Bank;
if ($this?.BankAccount == null) {return;}
let codes = bank?.StatementsConfiguration?.linq?.select((x) => x?.TransactionCode)?.toArray()?.linq?.distinct()?.toArray();
for (let _irow = 0; _irow < ($this?.Rows == null ? 0 : $this?.Rows.length); _irow++) {let row = $this?.Rows[_irow];row.RequiresInvoiceMatching = codes?.linq?.contains(row?.Code) && !(row?.HasInvoiceRule);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}